import useGetDirectLoanRequest from '../../../../services/hookService/getDirectLoanRequest/useGetDirectLoanRequest';
import SpinnerLoading from '../../../../components/SpinnerLoading';

interface IProps {
  loanRequestGuid: string;
}

const RejectLoanReceive = ({loanRequestGuid}: IProps) => {
  const {data, isLoading} = useGetDirectLoanRequest(loanRequestGuid);

  return (
    <div className="flex flex-col items-center justify-center gap-3 mt-16">
      <div className="flex items-center justify-center p-2 bg-red-600 rounded-full aspect-square">
        <i className="text-3xl font-semibold text-white icon-nameClose-remove" />
      </div>
      <span className="text-xl font-bold">عدم تایید برای تخصیص وام</span>

      <span className="my-4 text-gray-700 text-md">
        درخواست وام شما به یکی از دلایل زیر تایید نشد. بعد از رفع مشکل دوباره
        تلاش کنید.
      </span>

      {isLoading ? (
        <SpinnerLoading />
      ) : (
        data && (
          <div className="flex items-start justify-start w-full">
            <div
              className="w-full text-right text-md" // Full width with right-aligned text
              dangerouslySetInnerHTML={{__html: data?.rejection_reason}}
            />
          </div>
        )
      )}
    </div>
  );
};
export default RejectLoanReceive;
